/** @jsxImportSource @emotion/react */

interface SaveIconProps {
  size?: number
  color?: string
}

const SaveIcon = ({ size = 16, color = '#27303E' }: SaveIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 16 17'
      fill='none'
    >
      <path
        d='M11.3333 2.5H3.33333C2.59333 2.5 2 3.1 2 3.83333V13.1667C2 13.9 2.59333 14.5 3.33333 14.5H12.6667C13.4 14.5 14 13.9 14 13.1667V5.16667L11.3333 2.5ZM12.6667 13.1667H3.33333V3.83333H10.78L12.6667 5.72V13.1667ZM8 8.5C6.89333 8.5 6 9.39333 6 10.5C6 11.6067 6.89333 12.5 8 12.5C9.10667 12.5 10 11.6067 10 10.5C10 9.39333 9.10667 8.5 8 8.5ZM4 4.5H10V7.16667H4V4.5Z'
        fill={color}
      />
    </svg>
  )
}

export default SaveIcon
